// Logo "t" — réplica exacta del SVG inline del handoff (gradiente violeta +
// dot lima). Reusado en Nav, Footer y menú mobile.
export function LogoMark({ size = 28 }: { size?: number }) {
  const gradId = "tl-bm-bg";
  const glowId = "tl-bm-glow";
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" role="img" aria-label="Talenv">
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6B5CFF" />
          <stop offset="100%" stopColor="#3F4FFF" />
        </linearGradient>
        <radialGradient id={glowId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#D4FF5A" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#D4FF5A" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="32" height="32" rx="7" fill={`url(#${gradId})`} />
      <text x="13.5" y="24" textAnchor="middle" fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif" fontWeight="800" fontSize="22" fill="white" letterSpacing="-0.04em">t</text>
      <circle cx="23" cy="22" r="4.5" fill={`url(#${glowId})`} />
      <circle cx="23" cy="22" r="2.4" fill="#D4FF5A" />
    </svg>
  );
}
